import React, {useState} from 'react';
import type {EntityIdentifierEnum} from 'src/api/ProactApiClient';
import {useGetAuditLogListV2Query} from 'src/redux/queries/auditLog';
import {useAuditLogPermissions} from 'src/shared/auth/permissions/useAuditLogPermissions';
import useSkipTokensByFeature from 'src/shared/hooks/useSkipTokensByFeature';
import {AuditLogsList} from './AuditLogsList';

const maxPageRows = 10;

export interface AuditModuleProps {
  entityId: string;
  entityType: EntityIdentifierEnum;
}

export const AuditModule: React.FC<AuditModuleProps> = ({
  entityId,
  entityType,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const {skipAuditLogs} = useSkipTokensByFeature();
  const auditPerms = useAuditLogPermissions();

  const {
    data,
    isLoading: isLoadin,
    isFetching,
  } = useGetAuditLogListV2Query(
    {
      start: (currentPage - 1) * maxPageRows,
      length: maxPageRows,
      filters: [],
      filterFns: [],
      sorting: [{id: 'createdAt', desc: true}],
      entityId: entityId,
      entityType: entityType,
    },
    {refetchOnMountOrArgChange: true, skip: skipAuditLogs || !auditPerms.view}
  );

  const isLoading = isLoadin || isFetching;

  const rows = data?.data ?? [];
  const totalRecords = data?.totalRecords ?? 0;

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <AuditLogsList
      rows={rows}
      totalRecords={totalRecords}
      isLoading={isLoading}
      currentPage={currentPage}
      onPageChange={handlePageChange}
      maxPageRows={maxPageRows}
    />
  );
};
